import { useState } from "react";
import { Box, Tab } from "@mui/material";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import useStore from "../../store/useStore";
import SessionHabitatForm, { SessionHabitatFormForm } from "./HabitatForm";
import { Alert } from "@mui/material";

const SessionHabitatTabs = () => {
  const { session } = useStore((state) => state);
  const [value, setValue] = useState<string>("0");

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };

  //Affichage des infos enregistrées dans la session pour les anciennes (2022) sinon affichages de celles du site
  const dataList = session?.form.habitats
    ? session?.form.habitats
    : session?.site.habitats;

  return (
    <TabContext value={value}>
      {session?.form.habitats && (
        <Alert severity="warning">
          Les informations ci-dessous sont celles renseignées lors de la session
          et peuvent donc être différentes de celles actuelles du site.
        </Alert>
      )}
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <TabList onChange={handleChange} aria-label="session habitat tabs">
          {dataList?.map((habitat: SessionHabitatFormForm, index: number) => (
            <Tab
              key={index}
              label={`Habitat ${index + 1}`}
              value={String(index)}
            />
          ))}
        </TabList>
      </Box>
      {dataList?.map((habitat: SessionHabitatFormForm, index: number) => (
        <TabPanel sx={{ p: 0 }} key={index} value={String(index)}>
          <SessionHabitatForm form={habitat} />
        </TabPanel>
      ))}
    </TabContext>
  );
};

export default SessionHabitatTabs;
